//#region Styles
import {
    BodyRowText, 
    StudentCell, 
    SelectionCell } from "./styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
//#endregion

const StudentTableListResponsableItem = ({
    studentsSelected
}) => {
    return (
        <tr>
            <td>
                <StudentCell>
                    <BodyRowText color="var(--dark-4)">
                        Todos
                    </BodyRowText>
                </StudentCell>
            </td>
            <td>
            </td>
            <td>
                <SelectionCell>
                    <CustomCheckbox 
                        checked={studentsSelected.allAreSelected()}
                        onChange={studentsSelected.toggleAllSelected}
                        padding="0 10px"/>
                </SelectionCell>
            </td>
        </tr>
    );
}

export default StudentTableListResponsableItem;